import { z } from 'zod';

export enum DateRange {
  M1 = 'M1',
  M2 = 'M2',
  M3 = 'M3',
  M4 = 'M4',
  M5 = 'M5',
  M6 = 'M6',
  M7 = 'M7',
  M8 = 'M8',
  M9 = 'M9',
  M10 = 'M10',
  M11 = 'M11',
  M12 = 'M12',
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  YEAR = 'YEAR',
}
export const allDateRanges: DateRange[] = Object.values(DateRange);

export const zDateRangeAndYear = z.object({
  dateRange: z.nativeEnum(DateRange),
  year: z.number().int().positive(),
});
export type DateRangeAndYear = z.infer<typeof zDateRangeAndYear>;

export const zDateRangeRaw = z.object({
  startDate: z.string().date(),
  endDate: z.string().date(),
});
